/**
 * API Configuration
 */

// Determine base URL based on environment
const isProduction = window.location.hostname.includes('azurewebsites.net');

export const API_CONFIG = {
  // In development, Vite proxy will redirect /api to SSDS2 API
  // In production, API will be deployed separately
  baseURL: isProduction
    ? 'https://sen-prd-brs-api-svc-02.azurewebsites.net/v1'  // TODO: Update with actual production URL
    : '/api',  // Vite proxy handles this
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};
